<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner3.png" alt="">
        <div class="main" style="padding-bottom: 20px">
            <ul class="Breadcrumb">
                <li>首页</li>
                <li>></li>
                <li @click="backPage">行业应用</li>
                <li v-if="type">></li>
                <li v-if="type">{{ type }}</li>
            </ul>
            <div class="content">
                <div class="menu">
                    <Menu :mebuActive="active" @changeBreadcrumb="changeBreadcrumb" />
                </div>
                <div class="apply">
                    <div>
                        <div @click="getDetail(item)" v-for="(item, index) in applyList">
                            <div class="item">
                                <img :src="item.coverImage" :alt="item.description">
                            </div>
                            <p>{{ item.name }}</p>
                        </div>
                    </div>
                    <pagination v-if="applyList.length>0" style="margin-top:10px" :num="total" :limit="4" @getNew="getList"></pagination>
                </div>
                <!-- <div class="apply none" v-else>
                    暂无数据
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import Menu from './compontents/menu.vue'
import pagination from "@/components/page/pagination.vue"

import { getApplyPlanList, applyDomainList } from '../../api/index'
export default {
    components: {
        Menu, pagination
    },
    data() {
        return {
            applyList: [],
            type: "",
            active: -1,
            list: [],
            total: 0,
            id: ""
        }
    },
    methods: {
        changeBreadcrumb(item) {
            this.type = item.name
            this.id = item.id
            this.getList(0)
        },
        getDetail(item) {
            this.$router.push({ path: "/apply/ApplyDetail", query: { id: item.id, active: this.active } })
        },
        getList(val) {
            const params = {
                applyDomainId: this.id,
                pageNum: val,
                pageSize: 4,
            }
            getApplyPlanList(params).then(res => {
                this.applyList = res.rows
                this.total = res.total
                document.documentElement.scrollTop = 0;
            })
        },
        backPage(){
            this.id = ''
            this.getList(0)
            this.type = false
            this.active = -1
        },
    },
    watch: {
        $route: {
            handler(n, o) {
                this.id = n.query.id
                this.getList(0)
                if (this.$route.query.id) {
                applyDomainList().then(res => {
                    this.list = res.rows
                    for (let i = 0; i < this.list.length; i++) {
                        const element = this.list[i];
                        if (element.id == this.$route.query.id) {
                            this.active = i
                            return;
                        }
                    }
                })
            }
            },
            deep: true
        },
    },
    mounted() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id
            applyDomainList().then(res => {
                this.list = res.rows
                for (let i = 0; i < this.list.length; i++) {
                    const element = this.list[i];
                    if (element.id == this.$route.query.id) {
                        this.active = i
                        return;
                    }
                }
            })
        }
        this.getList(0)

    }
}
</script>
<style lang="scss" scoped>
.content {
    display: flex;

    .menu {
        width: 250px;
    }

    .apply {
        margin-left: 30px;
        flex: 1;

        >div {
            overflow: hidden;
            box-sizing: border-box;

            >div {
                width: 50%;
                float: left;
                height:365px;
                overflow:hidden;
                >div {
                    overflow: hidden;
                }
            }

            >div:nth-child(odd) {
                padding-right: 10px;
            }

            >div:nth-child(even) {
                padding-left: 10px;
            }
        }



        p {
            color: #4d4d4d;
            line-height: 30px;
            text-overflow: ellipsis; ///超出部分省略号显示
            display: -webkit-box; //弹性盒模型
            -webkit-box-orient: vertical; //上下垂直
            -webkit-line-clamp: 2;
            font-size: 18px;
            padding: 6px 10px 20px 10px;
            overflow: hidden;
        }

        .item {
            height: 270px;
            cursor: pointer;

            img {
                transform: scale(1, 1);
                transition: all 0.3s linear;
                width: 100%;
                height: 100% !important;
            }
        }

        .item:hover {
            img {
                transform: scale(1.2, 1.2);
                transition: all 0.3s linear;
            }
        }
    }
}

.none {
    text-align: center;
    display: table-cell;
    line-height: 400px;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/apply/index.vue